import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';


export interface SchoolContactUpsertState extends ApiState {
  contactId?: string
}

export default requestReducer<SchoolContactUpsertState>('SCHOOL_CONTACT_UPSERT')
